import "./index.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BellCorpStudioLogoContainer } from "../../common-utilities/Bellcorp-Studio-Logo";
import BasicHeader from "../../common-utilities/core/basic-header";
import { getOfflineData } from "../utils/offline-services";
import IntranetHeader from "../../../core/header";
import HomeRedirect from "../../common-utilities/core/home-redirect";
import { tokenMainKeys } from "../../../utils/constants";
import { invokeApi, HTTP_METHODS } from "../utils/http-service";
import { CF_APPROVAL_HOSTNAME } from "../../common-utilities/utils/end-points";
import { REST_URLS } from "../../common-utilities/utils/end-points/cf-approval";
import { setStepMaster } from "../../../reducer/cfApprovalV2";

const MainContainer = ({ children }) => {
  const dispatch = useDispatch();
  const stepMasterLoaded = useSelector((state) => state.cfApprovalV2.stepMasterLoaded);

  // Load Step Master once when the app opens and keep it in redux for all components.
  useEffect(() => {
    if (stepMasterLoaded) return;
    invokeApi(HTTP_METHODS.GET, `${CF_APPROVAL_HOSTNAME}${REST_URLS.CF_V2_STEP_MASTER}`)
      .then((steps) => {
        const all = Array.isArray(steps) ? steps : steps?.result || [];
        dispatch(setStepMaster(all));
      })
      .catch(() => dispatch(setStepMaster([])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="main-container">
        <IntranetHeader />
        <div className="side-nav-header">
          <HomeRedirect localstorageKey={tokenMainKeys.cfApprovalV2} />
          <h5 className="app-name" style={{ marginLeft: 10 }}>
            NSO CF approval
          </h5>
        </div>

        <div className="main-right-container">
          <BasicHeader userDetails={getOfflineData("user")} />
          <div className="content-div">
            <div>{children}</div>
            <BellCorpStudioLogoContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContainer;
